import styles from "../../../LoanRequestPage.module.scss";
import { AttachmentIcon } from "../../../../../../assets/icons";
import { OrderType } from "../../../../../../model/orders/orders";

type Props = {
	orderDetails: OrderType;
};

const AddressTab = ({ orderDetails }: Props) => {
	const { customer } = orderDetails;

	const imgUrl = customer?.addressProofUrl ?? "";

	return (
		<section className={styles.detailsTabWrapper}>
			<div className={styles.detailsContent}>
				<div className={styles.item}>
					<div className={styles.label}>Address Submitted</div>
					<div className={styles.value}>
						{customer.address}
						{customer.city ? `, ${customer.city}` : ""}
					</div>
				</div>
				<div className={styles.item}>
					<div className={styles.label}>Meter Number Address</div>
					<div className={styles.value}>{customer.meterNumber}</div>
				</div>
				<div className={styles.item}>
					<div className={styles.label}>BVN Name</div>
					<div className={styles.value}>
						<div className={styles.value}>
							{!(customer?.bvnVerifyDetails?.firstName && customer?.bvnVerifyDetails?.lastName && customer?.bvnVerifyDetails?.middleName) ? (
								"/"
							) : (
								<>
									{customer?.bvnVerifyDetails?.firstName} {customer?.bvnVerifyDetails?.middleName} {customer?.bvnVerifyDetails?.lastName}
								</>
							)}
						</div>
					</div>
				</div>
				<div className={styles.item}>
					<div className={styles.label}>Uploaded Proof of Address</div>
					<div className={styles.value}>
						<div className={styles.attachment} onClick={() => {
							window.open(imgUrl, "_blank");
						}}>
							<AttachmentIcon />
							View attachment
						</div>
					</div>
				</div>
				<div className={styles.item}>
					<div className={styles.label}>Address Success Rate</div>
					<div className={styles.value}>{customer?.addressVerificationDetails?.confidenceLevel !== undefined ? `${customer.addressVerificationDetails?.confidenceLevel}%` : "Address was not valid"}</div>
				</div>
			</div>
		</section>
	);
};

export default AddressTab;
